import { Component, OnInit, ViewChild, ElementRef  } from '@angular/core';
import { Company } from '../../../models/Company.model';
import { CompanyGroup } from '../../../models/CompanyGroup.model';
import { CompaniesService } from '../../../services/companies.service';
import {ConsultantService} from '../../../services/consultant.service';
import { ProductService } from '../../../services/product.service';
import { OwnerService } from '../../../services/billing-letter/owner.service';
import { Owner } from '../../../models/billing-letter/Owner.model';
import { CompanyGroupSearch } from "../../../models/CompanyGroupSearch.model";
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { CommonHelper } from '../../../shared/helpers/CommonHelper';
import { GroupDivision } from '../../../shared/enums/GroupDivision';
import { DropdownItemFactory } from '../../../shared/factories/dropdown/dropdown-item.factory';
import { DropdownSettingsFactory } from '../../../shared/factories/dropdown/dropdown-settings.factory';
import { Router } from '@angular/router';
import { ToastsManager } from "ng2-toastr";
import { HashtrackService } from "../../../services/hashTrack.service";
import { AwsService } from '../../../services/aws.service';
import { BankService } from '../../../services/bank.service';
import { ExternalReferenceFinancial } from '../../../models/ExternalReference.model';
import { GUARDS } from '../../../shared/auth/Roles';
import { LocalStorage } from '../../../shared/wrappers/LocalStorage';
import * as moment from 'moment';
import * as _ from 'lodash';
import {ConsultantSearch} from "../../../models/ConsultantSearch.model";
import { PixKeyType } from '../../../shared/enums/PixKeyType'
import { PixValidation } from '../../../shared/helpers/PixValidation';
import { CompanyService } from '../../../services/billing-letter/company.service';
import { Industry } from '../../../models/Industry.model';
import { IndustriesService } from '../../../services/industries.service';
import { CnaeService } from '../../../services/cnae.service';
import { SapItemType } from '../../../shared/enums/SapItemType';

@Component({
  selector: 'app-companie-create',
  templateUrl: './companie-create.component.html',
  styleUrls: ['./companie-create.component.css']
})
export class CompanieCreateComponent implements OnInit {
  @ViewChild('uploadInput') uploadInput:ElementRef;
  hashCustomers;
  emails: string[];
  name: string;
  companyForm: FormGroup;
  cnpjPattern = /^([0-9]{2}\.?[0-9]{3}\.?[0-9]{3}\/?[0-9]{4}\-?[0-9]{2})$/i;
  mask = [/[0-3]/,/[0-9]/,'/',/[0-3]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/];
  cnpjMask = [/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'.',/[0-9]/,/[0-9]/,/[0-9]/,'/',/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,'-',/[0-9]/,/[0-9]/];
  accountMask = [/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,] ;
  agencyMask = [/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/,/[0-9]/] ;
  digitMask = [/[A-Za-z0-9]/];
  datePattern = /^(0[1-9]|1[0-9]|2[0-9]|3[01]).(0[1-9]|1[012]).[0-9]{4}$/i;
  phoneMask = ['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/] ;
  emailPattern = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  company: Company = new Company();
  commonHelper: CommonHelper = new CommonHelper();
  companyGroups: CompanyGroup[] = new Array<CompanyGroup>();
  companyGroupSearchModel: CompanyGroupSearch;
  DropDownHash;
  DropDownSettings;
  selectedHash;
  loading: boolean;
  selectedFiles:FileList;
  managers: Owner[] = [];
  banks : any = [];

  pixKeyVerifyMethod : any;
  pixKeyFlag: Boolean = true;
  pixCpfValid : Boolean;
  pixCnpjValid : Boolean;
  phoneMaskFlag: Boolean = false;
  textMask;

  canSave: Boolean = true;
  allowedRoles = [GUARDS.MANAGER, GUARDS.JUDICIARY, GUARDS.GOVERNANCE, GUARDS.FINANCES, GUARDS.DP, GUARDS.BILLSRECEIVE];
  user;

  industries: Industry[] = new Array<Industry>();

  items = [];
  itemsDropdown = {
    list: [],
    options: null,
    selected: []
  };

  constructor(private companiesService: CompaniesService,
    private companyService: CompanyService,
    private consultantService: ConsultantService,
    private productService: ProductService,
    private ownerService: OwnerService,
    private localStorage: LocalStorage,
    private formBuilder: FormBuilder,
    private dropDownItemFactory: DropdownItemFactory,
    private dropDownSettingFactory: DropdownSettingsFactory,
    private router: Router,
    private tostr: ToastsManager,
    private industriesService: IndustriesService,
    private awsService: AwsService,
    private hashtrackService: HashtrackService,
    private bankService: BankService,
    public pixValidation: PixValidation,
    private cnaeService: CnaeService) { }


  async ngOnInit() {
    this.loading = true;
    this.textMask = {mask: false}
    this.companyForm = this.formBuilder.group({
      name: [null, Validators.required],
      companyName: [null, Validators.required],
      industry: [null, [this.validateSelectOptionIndustries]],
      companyGroup: [null, [this.validateSelectOption]],
      ownerName: [null, [this.validateSelectOption]],
      manager: [null, [this.validateSelectOption]],
      cnpj: [{disabled:true}, [Validators.required, Validators.pattern(this.cnpjPattern)]],
      emails: [null, Validators.required],
      keyPix:[null, [this.validateKeyPix]],
    });

    this.company.isCustomer = false;
    this.checkPermissions();

    this.industries = await this.industriesService.getAll();
    this.hashCustomers = await this.hashtrackService.getAllCustomers();
    this.DropDownHash = this.commonHelper.getDropDownListItems(this.hashCustomers, "_id", "name");
    this.DropDownSettings = this.commonHelper.getDropDownSettings(true, "Cliente", false, "", "", true,null, "");

    this.companyGroupSearchModel = new CompanyGroupSearch();
    this.companyGroupSearchModel.allItems = true;
    this.companyGroups = await this.companiesService.searchCompanyGroups(this.companyGroupSearchModel);

    this.items = await this.cnaeService.getAllItems([SapItemType.ItemPurchaseOrder]);
    this.items = _.orderBy(this.items,[item => item.name.toUpperCase()]);
    this.itemsDropdown.options = this.dropDownSettingFactory.build({text:'Item do pedido',singleSelection:false,enableCheckAll:false});
    this.itemsDropdown.list = this.dropDownItemFactory.build({source:this.items});

    this.managers = await this.ownerService.getAll();
    this.banks = await this.bankService.getBanks();
    this.company.payment.typePix = 0
    this.companyForm.get("keyPix").disable();
    this.changeCompanyType();
    this.loading = false;
  }

  changeIndustryType() {
    if(this.company.isCustomer) {
        this.companyForm.get("industry").enable();
        return;
    }

    this.companyForm.get("industry").disable();
  }

  checkPermissions() {
    this.user = this.localStorage.retrieve('user');
    if(!this.allowedRoles.includes(this.user.permission)) {
        this.canSave = false;
        this.company.isCustomer = false;
    }
  }

  validateSelectOptionIndustries(control: AbstractControl) {
    if (!control.value || control.value == "")
    return {valid: true};

    return null;
  }

  async OnSave() {
    try {
        if(!this.company.payment.keyPix && this.company.payment.typePix != 0){
            this.tostr.warning("A chave pix é obrigatória")
            return;
        }

        if (this.companyForm.valid) {

            if(this.company.companyName.length > 100)
                return this.tostr.warning('O nome da empresa é longo demais, permitido apenas 100 caracteres!');

            this.company.manager.name = this.managers.find(x => x._id === this.company.manager._id).name;
            this.company.owner.name = this.managers.find(x => x._id === this.company.owner._id).name;

            if (this.selectedHash && this.selectedHash.length > 0) {
                this.company.externalReference = new ExternalReferenceFinancial();
                this.company.externalReference._id = this.selectedHash[0].id;
                this.company.externalReference.name = this.selectedHash[0].itemName;
            } else
                this.company.externalReference = null;

            if(this.company.companyGroup._id != '' && this.company.companyGroup._id != undefined)
                this.company.companyGroup.name = this.companyGroups.find(x => x._id === this.company.companyGroup._id).name;

            if(this.company.industry)
                this.company.industry = this.industries.find(x => x._id === this.company.industry._id);

            // VALIDAÇÃO QUANDO A EMPRESA É FC NUVEM PARA CADASTRO DE CONTRATO CLICKSIGN
            // if(this.company.group == 5 && this.company.typeContract == ''){
            //   this.tostr.warning('Selecione o tipo de contrato FC NUVEM');
            // } else {
            // }

            if(!this.company.isCustomer && this.itemsDropdown.selected.length > 0){
                const itemsSelected = this.itemsDropdown.selected.map(item => {
                    return item.sapItemCode;
                });
                this.company.defaultItems = itemsSelected;
            }

            this.loading = true;
            let response = await this.companiesService.create(this.company);
            if(response._id){
                this.loading = false;
                if(this.selectedFiles){
                    this.upload(response._id);
                }
                this.tostr.success('Empresa criada com sucesso!');
                this.router.navigate(['/companies']);
            } else {
                this.loading = false;
                this.tostr.warning("Erro ao criar empresa");
            }
        }

    } catch(err){
        this.loading = false;
        console.log(err)
        this.tostr.warning("Erro ao criar empresa");
    }
  }

  OnClear() {
    this.company = new Company();
    this.uploadInput.nativeElement.value = '';
  }

  verifyValidTouched(fieldName) {
    return !this.companyForm.get(fieldName).valid && this.companyForm.get(fieldName).touched;
  }

    validateSelectOption(control: AbstractControl) {
        if (control.value == 0 || control.value == '0' ||
            control.value == 'undefined' || control.value == undefined)
            return {division: true};
        return null;
    }

    trim(){
        if(this.company.payment.keyPix)
            this.company.payment.keyPix = this.company.payment.keyPix.trim();
      }

  applyErrorCss(fieldName) {
    return {
      'has-error': this.verifyValidTouched(fieldName)
    }
  }

  verifyDate(date,field){
    if(!(new RegExp(this.datePattern).test(date))){
        this.tostr.warning(`Digite uma data válida.`,"Data inválida!");
        this.company[`${field}`] = "";
    }
  }

  async verifyCNPJ(){
    if(this.company.cnpj == '' || this.company.cnpj == undefined) {
        this.tostr.warning('CNPJ não pode ser vazio');
    } else {
      let response = await this.companiesService.verifyCnpj(this.company);
      if(response.length > 0){
        this.tostr.warning(
            `O CNPJ está cadastrado para o ${this.company.isCustomer ? 'cliente' : 'fornecedor'} ${response[0].name?response[0].name:""}`,
            'CNPJ em uso!'
        );
        this.company.cnpj = '';
        this.company.name = '';
        this.company.companyName = '';
      } else {
        await this.cnpjSearch();
      }
    }
  }

  async cnpjSearch(){
    if(this.company.cnpj == '' || this.company.cnpj == undefined) {
        this.tostr.warning('CNPJ não pode ser vazio');
    } else if (!this.companiesService.cnpjValid(this.company.cnpj)) {
        this.tostr.warning('CNPJ inválido. CNPJ deve ter 14 caracteres!');
    } else {
        this.tostr.warning('Realizando consulta ao CNPJ...');
        let response = await this.companiesService.getCnpj(this.company.cnpj);
        if(response.status == 'ERROR'){
            this.tostr.warning(response.message);
        } else {
          if(response.fantasia != '') this.company.name = response.fantasia;
          if(response.nome != '') this.company.companyName = response.nome;
          if(response.logradouro != '') this.company.address.street = response.logradouro;
          if(response.numero != '') this.company.address.number = response.numero;
          if(response.complemento != '') this.company.address.complement = response.complemento;
          if(response.municipio != '') this.company.address.city = response.municipio;
          if(response.uf != '') this.company.address.uf = response.uf;
          if(response.bairro != '') this.company.address.district = response.bairro;
          if(response.cep != '') this.company.address.zipCode = response.cep;
          if(response.tipo != '') this.company.address.type = response.tipo;
        }
    }
  }
  
  async verifyCPFCNPJPixKey(){
        if(this.company.payment.keyPix == null || this.company.payment.keyPix == ""){
            this.tostr.warning("O CPF/CNPJ é obrigatório!");
            this.company.payment.keyPix = "";
        } else if(this.commonHelper.cpfValidator(this.company.payment.keyPix)){
            this.pixCpfValid = true;
        } else if(this.companiesService.cnpjValid(this.company.payment.keyPix)){
        this.pixCnpjValid = true;
        }else if(!this.pixCnpjValid && !this.pixCpfValid){
        this.tostr.warning('CPF/CNPJ inválido.');
        this.company.payment.keyPix = "";
        }
    }

    cnpjValid(cnpj: String) {
        return this.companiesService.cnpjValid(cnpj);
    }

    async getCnpj(cnpj: String) {
        return await this.companiesService.getCnpj(cnpj);
    }

    randomPixKeySearch(){
        if(this.company.payment.keyPix == '' || this.company.payment.keyPix == undefined) {
            this.tostr.warning('Aleatório não pode ser vazio');
        } else if (!this.companyService.randomPixKeyValid(this.company.payment.keyPix)) {
            this.tostr.warning('Aleatório inválido. Aleatório deve ter 36 caracteres!');
            this.company.payment.keyPix = ''
        }
    }

    async verifyEmailPixKey(){
        this.trim();

        if(this.company.payment.keyPix == null || this.company.payment.keyPix == ""){
        this.tostr.warning("O Email é obrigatório!");
        this.company.payment.keyPix = "";
        }else{
            if (!(new RegExp(this.emailPattern).test((this.company.payment.keyPix).toString()))) {
                this.tostr.warning(`Digite um email válido.`, "Email inválido!");
                this.company.payment.keyPix = "";
            }
        }
    }

  selectFile(event) {
    this.selectedFiles = event.target.files;
  }

  upload(id) {
    let length = this.selectedFiles.length;
    for(let i=0; i<length; i++){
      const file = this.selectedFiles.item(i);
        this.awsService.uploadfile(file,id);
    }
  }

  changeCompanyType() {
    if(this.company.isCustomer) {
        this.company.group = GroupDivision.NaoRegistrado;
        this.company.owner._id = '';
        this.company.manager._id = '';
        this.company.companyGroup._id = '';
    } else {
        const FABIO_CAMARA_ID = '58f778022b759f6d18f8801c',
              FCAMARA_ID = '5df971e8e662bd001c2755f8';
        this.company.owner._id = FABIO_CAMARA_ID;
        this.company.manager._id = FABIO_CAMARA_ID;
        this.company.companyGroup._id = FCAMARA_ID;
        this.company.group = GroupDivision.Omnik;
        this.itemsDropdown.selected = [];
    }
    this.changeIndustryType();
  }

  emailBlur() {
    this.tostr.warning('Aperte ENTER para confirmar a inserção do e-mail');
  }

    onPixTypeChange() {
        this.pixValidation.onPixTypeChange(this.company.payment.typePix, this.companyForm.get("keyPix"))
        this.textMask = {mask: false}
    }

    async verifyPixKey(){
        if (!this.company.payment.typePix) {
            return
        }
        this.pixCpfValid = false;
        this.pixCnpjValid = false;

        let typePix = this.company.payment.typePix

        switch (typePix) {
            case PixKeyType.phone:
                if(!this.commonHelper.phoneNumberValidator(this.company.payment.keyPix)){
                    this.tostr.warning('CPF/CNPJ inválido.');
                    this.company.payment.keyPix = "";
                }
                break;
            case PixKeyType.email:
                this.verifyEmailPixKey();
                break;
            case PixKeyType.cpf_cnpj:
                this.verifyCPFCNPJPixKey();
                break;
            case PixKeyType.randomized:
                this.randomPixKeySearch();
                break;
            default:
                break;
        }
    }

    onChangeMask() {
        let typePix = this.company.payment.typePix;
        switch (typePix) {
            case PixKeyType.phone:
                this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.phone)
                break;
            case PixKeyType.cpf_cnpj:
                let inputValue = this.company.payment.keyPix;
                if(!inputValue) return;

                if (inputValue && inputValue.length > 14)
                    this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.cpf_cnpj, true);
                else
                    this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.cpf_cnpj, false);
                break;
            case PixKeyType.randomized:
                this.textMask = this.pixValidation.verifyMaskPixKey(PixKeyType.randomized)
                break;
            default:
                break;
        }
    }

    validateKeyPix(control: AbstractControl){
        if(!control.value) return {keyPix:true}
            return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/companies/companie-create/companie-create.component.ts